import InstitutionInfoText from "./institution-info-text";

export default InstitutionInfoText;
